import { render, staticRenderFns } from "./LivePeople.vue?vue&type=template&id=3e0f0983&scoped=true&"
import script from "./LivePeople.vue?vue&type=script&lang=js&"
export * from "./LivePeople.vue?vue&type=script&lang=js&"
import style0 from "./LivePeople.vue?vue&type=style&index=0&id=3e0f0983&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f0983",
  null
  
)

export default component.exports